import * as React from 'react';

import { createIcon } from '../Icon';
export const BluetoothIcon = createIcon(
  <polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5" />,
  'BluetoothIcon'
);
